import { ReactNode } from 'react'
import styled from 'styled-components'
import { theme } from '../../../theme/theme'
import { printAccentBar } from '../../../theme/print'
import { BodyMedium, Title3 } from '../../styles/Typography'

type Props = {
  title: string
  intro: string
  introDetail?: ReactNode
  children: ReactNode
}

export const StatisticsSection = ({ title, intro, introDetail, children }: Props) => (
  <Section>
    <SectionHeader>
      <SectionTitle>{title}</SectionTitle>
      <SectionIntro>{intro}</SectionIntro>
      {introDetail && <SectionIntro>{introDetail}</SectionIntro>}
    </SectionHeader>
    {children}
  </Section>
)

// Each section draws the rule above itself, so one lands between every pair and none at the top.
const Section = styled.section`
  border-top: 1px solid ${theme.color.beigeDark};
  padding-top: ${theme.spacing.xxlarge}px;
  margin-bottom: ${theme.spacing.xxlarge}px;

  &:first-of-type {
    border-top: none;
    padding-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
`

const SectionHeader = styled.div`
  @media print {
    break-inside: avoid;
    break-after: avoid;

    &::before {
      content: '';
      ${printAccentBar}
    }
  }
`

const SectionTitle = styled(Title3)`
  color: ${theme.color.plum};
  margin-bottom: ${theme.spacing.xsmall}px;
`

const SectionIntro = styled(BodyMedium)`
  color: ${theme.color.blueDark};
  max-width: 760px;
  margin-bottom: ${theme.spacing.mediumLarge}px;
`
